import { render, staticRenderFns } from "./ChatService.vue?vue&type=template&id=e9566de0&scoped=true"
import script from "./ChatService.vue?vue&type=script&lang=js"
export * from "./ChatService.vue?vue&type=script&lang=js"
import style0 from "./ChatService.vue?vue&type=style&index=0&id=e9566de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9566de0",
  null
  
)

export default component.exports